import { StatIcon } from "../icons";
import List from "./List";

export default {
  options: {
    group: "dashboard",
    roles: ["user", "admin", "insights"],
  },
  icon: StatIcon,
  list: List,
};
